import styled from '@emotion/styled';
import { Box, TextField, IconButton } from '@mui/material';

export const InputWrapper = styled(Box)(() => ({
    padding: '15px 20px',
    borderTop: `1px solid var(--grey-200)`,
    backgroundColor: 'var(--grey-100)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    paddingLeft: '15%',
}));

export const StyledTextField = styled(TextField)(() => ({
    flexGrow: 1,
    '& .MuiOutlinedInput-root': {
        borderRadius: '20px',
        backgroundColor: 'white',
        paddingRight: '10px',
        '&:hover fieldset': {
            borderColor: 'var(--secondary-light)',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'var(--secondary-main)',
        },
    },
    '& .MuiOutlinedInput-input': {
        padding: '8px 8px',
        fontSize: '0.95rem',
        minHeight: '20px',
    },
    '& .MuiOutlinedInput-notchedOutline legend': {
        display: 'none',
    },
    '& textarea': {
        resize: 'none',
        minHeight: '40px',
        maxHeight: '150px',
    },
}));

export const SendButton = styled(IconButton)(() => ({
    backgroundColor: 'var(--secondary-main)',
    color: 'white',
    width: '40px',
    height: '40px',
    '&:hover': {
        backgroundColor: 'var(--secondary-dark)',
    },
    '&.Mui-disabled': {
        backgroundColor: 'var(--grey-300)',
    },
}));
